import { space } from '../spacing.js';
export const uiText = {
    control: {
        fontSize: 's',
        lineHeight: 'm',
        fontWeight: 'emphasised',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    label: {
        fontSize: 'xs',
        lineHeight: 's',
        fontWeight: 'emphasised',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    input: {
        fontSize: 's',
        lineHeight: 'm',
        fontWeight: 'standard',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    placeholder: {
        fontSize: 's',
        lineHeight: 'm',
        fontWeight: 'standard',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
};
export const uiInterspersedText = {
    margin: `${space.x0} ${space.x2}`,
};
//# sourceMappingURL=ui-text.js.map